import { GetAuthToken } from '@domain/auth/AuthContext';
import { trackEvent } from '@domain/analytics/trackEvent';
import { ICoupon } from '@app-types/stripe';

import { get, returnJsonOrThrow } from './shared';

export const validateCode = async (code: string, getAuthToken: GetAuthToken): Promise<ICoupon> =>
  get(`/premium/coupons/${code}`, getAuthToken)
    .then((response: Response) => {
      trackEvent({
        name: 'premium_discount_code_validated',
        properties: { valid: response.ok, discount_code: code },
      });
      return response;
    })
    .then(async r => returnJsonOrThrow<ICoupon>(r));
